import { MeRepository, ActivationCodesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';

const _directiveDependencies = [];
const _controllerDependencies = ['$state', 'Auth'];

class UserSettingsController {

    constructor($state, Auth) {

        const { freeSupport } = CWCONFIG.partnerConfig.support;

        this.topQA = `https://www.avira.com/${CWCONFIG.language}/support`;
        this.privacyPolicyUrl =
            CWCONFIG.partnerConfig.translationsLinks.generalPrivacy.replace('{language}', CWCONFIG.language);

        if (CWCONFIG.language === 'en') {

            this.supportForFreeUsersLink = freeSupport.replace(/\[language\]/gi, 'en-us');

        } else {

            this.supportForFreeUsersLink = freeSupport.replace(/\[language\]/gi, CWCONFIG.language);

        }

        this.User = MeRepository.getMyUser();
        this.$state = $state;
        this.Auth = Auth;

        const activationCodes = ActivationCodesRepository.getAll() || [];

        if (activationCodes.length > 0) {

            this.supportForPaidUsers = true;

        }

    }

    sendMixpanel(modalName) {

        Mixpanel.send(`ConnectWeb ${modalName} Click`, {
            Label: 'User Settings Menu',
        });

    }

    openMyAccount() {

        Mixpanel.send('ConnectWeb My Account Open');
        this.sentEventManager();
        this.$state.go('root.dashboard.my-account', { tab: 'profile' });

    }

    openSubscriptions() {

        this.$state.go('root.dashboard.subscriptions', { tab: 'plans' });

    }

    logOut() {

        this.Auth.logOut();

    }
    sentEventManager() {

        eventManager.broadcast('user-menu:clicked');

    }

}

class UserSettingsDirective {

    constructor() {

        this.template = require('./user-settings.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($state, Auth) =>
            new UserSettingsController($state, Auth));
        this.controller = _controllerDependencies;
        this.controllerAs = 'userSettingsCtrl';

    }

}

_directiveDependencies.push(() => new UserSettingsDirective());

angular.module('directives')
    .directive('userSettings', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/header/user-settings/user-settings.js